module.exports = __webpack_public_path__ + "static/bw-profile-pic-3f50ff1f04da66cc4804139f9f783503.jpg";